import { Component, NgModule, ViewChild, EventEmitter, Output, Input, SimpleChanges, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Router } from '@angular/router';
import { DxButtonModule, DxDataGridComponent, DxDataGridModule, DxDropDownButtonModule, DxSelectBoxModule, DxTextBoxModule, DxToolbarModule } from 'devextreme-angular';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { DxTabsTypes } from 'devextreme-angular/ui/tabs';
import { StatusIndicatorModule } from 'src/app/components';
import { exportDataGrid as exportToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportToXLSX } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { jsPDF } from 'jspdf';
import { taskPriorityList, taskStatusList } from 'src/app/types/task';
import { WorkRequest } from 'src/app/types/work-request';
import 'jspdf-autotable';

@Component({
	selector: 'work-request-list-grid',
	templateUrl: './work-request-list-grid.component.html',
	styleUrls: ['./work-request-list-grid.component.scss'],
})
export class WorkRequestListGridComponent implements OnChanges {
	@ViewChild(DxDataGridComponent, { static: false }) grid: DxDataGridComponent;

	@Input() dataSource: WorkRequest[];

	@Output() tabValueChanged: EventEmitter<any> = new EventEmitter<EventEmitter<any>>();

	workRequests: WorkRequest[];

	priorityList = taskPriorityList;

	statusList = taskStatusList;

	isLoading = true;

	useNavigation = true;

	constructor(private router: Router) {
	}

	refresh() {
		this.grid.instance.refresh();
	}

	showColumnChooser() {
		this.grid.instance.showColumnChooser();
	}

	search(text: string) {
		this.grid.instance.searchByText(text);
	}

	onExportingToPdf() {
		const doc = new jsPDF();
		exportToPdf({
			jsPDFDocument: doc,
			component: this.grid.instance,
		}).then(() => {
			doc.save('WorkRequests.pdf');
		});
	};

	onExportingToXLSX() {
		const workbook = new Workbook();
		const worksheet = workbook.addWorksheet('WorkRequests');

		exportToXLSX({
			component: this.grid.instance,
			worksheet,
			autoFilterEnabled: true,
		}).then(() => {
			workbook.xlsx.writeBuffer().then((buffer) => {
				saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'WorkRequests.xlsx');
			});
		});
	};

	ngOnChanges(changes: SimpleChanges) {
		if (changes.dataSource) {
			this.workRequests = changes.dataSource.currentValue;
//			this.tasks = changes.dataSource.currentValue.filter((item) => !!item.status && !!item.priority);
		}
	};

	toogleUseNavigation = () => {
		this.useNavigation = !this.useNavigation;
	};

	tabsItemClick = (e: DxTabsTypes.ItemClickEvent) => {
		this.tabValueChanged.emit(e);
	};

	navigateToDetails = (e: DxDataGridTypes.RowClickEvent) => {
		this.router.navigate([`/work-request-details/${e.data.id}`]);
	};
}

@NgModule({
	imports: [
		DxButtonModule,
		DxDataGridModule,
		DxDropDownButtonModule,
		DxSelectBoxModule,
		DxTextBoxModule,
		DxToolbarModule,

		StatusIndicatorModule,

		HttpClientModule,
		CommonModule,
	],
	providers: [],
	exports: [WorkRequestListGridComponent],
	declarations: [WorkRequestListGridComponent],
})
export class WorkRequestListGridModule { }
